exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-input-number[data-v-51a104ed] {\r\n  width: 120px;\n}\r\n", ""]);

// exports
